/*=========================================================================================
  File Name: state.js
  Namespace: passes
  Description: Vuex Store - Pass state
==========================================================================================*/

export const buildPassState = () => {
  return {
    id: null,
    name: '',
    slug: '',
    course_rules: [],
    learning_path_rules: [],
    courses: [],
    learning_paths: [],
    restricted_to: 'Video,Quiz,Coding Exercise'
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  currentPass: buildPassState(),
  passList: null,
  count: 0,
  next: null,
  previous: null,
  results: []
}

export default state